module.exports = __webpack_public_path__ + "img/4064009360.d075354d.jpg";